// src/servicesData.js
import { FaIdBadge } from "react-icons/fa";
import { MdHealthAndSafety } from "react-icons/md";
import { TbCertificate } from "react-icons/tb";

export const services = [
  {
    slug: "personal-injury",
    icon: <MdHealthAndSafety className="text-accent text-4xl mb-4" />,
    title: "Personal Injury",
    blurb:
      "Accidents are a dreadful part of life, yet they are frequently avoidable. Injuries that could have been prevented due to someone else’s carelessness or irresponsible behavior often lead to long-term consequences. When this happens, you deserve strong advocacy and a clear path forward.",
    bullets: [
      "Accident & injury case evaluation",
      "Determination of negligence and liability",
      "Strategic negotiation with insurance companies",
      "Guidance on documenting injuries and damages",
      "Support throughout the claims and recovery process",
    ],
    // pricing: [
    //   {
    //     name: "Contingency-Based Representation",
    //     desc: "Most personal injury matters are handled on a contingency basis — meaning no attorney’s fees unless compensation is recovered for you.",
    //   },
    // ],
    extra:
      "At Cire Legal, we recognize that personal injuries have a life changing impact on victims. You owe it to yourself to work with a personal injury attorney who can defend your rights, communicate with insurance companies, and pursue the compensation needed to support your recovery. With us by your side, you gain both protection and a path toward justice.",
  },
  {
    slug: "trademarks",
    icon: <TbCertificate className="text-accent text-4xl mb-4" />,
    title: "Trademarks & Brand Protection",
    blurb:
      "Trademarks are among the most valuable assets a business can own. Whether you're developing a new brand or refining an existing one, protecting your name, logo, or slogan is essential to preserving your reputation and avoiding costly disputes.",
    bullets: [
      "Federal trademark registration with the USPTO",
      "Comprehensive clearance searches & risk analysis",
      "Responses to USPTO office actions",
      "Cease & desist letters and enforcement strategy",
      "Trademark monitoring & brand protection guidance",
    ],

    pricing: [
      { item: "Trademark Search & Legal Opinion", price: "$350 flat fee" },
      {
        item: "Trademark Application Filing",
        price: "$950 attorney fee + USPTO fees ($250–$350/class)",
      },
      {
        item: "Comprehensive Trademark Package",
        price: "$1,350 + USPTO fees",
        note: "Includes search, legal opinion, application, and 12 months of monitoring.",
      },
      {
        item: "Office Action Response",
        price: "$250–$1,200 depending on complexity",
      },
      {
        item: "Trademark Monitoring",
        price: "$25/month or $250/year",
      },
    ],
    // pricing: [
    //   {
    //     name: "Trademark Filing & Strategy Consultation",
    //     desc: "Tailored guidance on trademark eligibility, filing strategy, and the steps required to safeguard your brand identity.",
    //   },
    //   {
    //     name: "Trademark Enforcement Support",
    //     desc: "Assistance with cease and desist letters, infringement response, and ongoing brand protection measures.",
    //   },
    // ],
    extra:
      "At Cire Legal, clients receive thoughtful and individualized support focused on trademark protection and brand development. Whether you're a first-time business owner or an established entrepreneur looking to expand, you receive clear communication, strategic guidance, and legal insight tailored to your goals.",
  },

  {
    slug: "nil-legal-strategy",
    icon: <FaIdBadge className="text-accent text-4xl mb-4" />,
    title: "NIL (Name, Image & Likeness) Strategy",
    blurb:
      "The NIL era has fundamentally reshaped college athletics. Today’s student-athletes are no longer just competitors they are entrepreneurs. Whether you're negotiating contracts, managing your brand, or navigating compliance issues, proactive business planning is essential to protect your interests and secure your financial future.",
    bullets: [
      "NIL brand development and strategic positioning",
      "Review of NIL agreements, sponsorships, and endorsements",
      "Compliance guidance for school, conference, and NCAA regulations",
      "Risk assessment before signing deals with brands or agencies",
      "Long-term planning for asset protection, income stability, and brand expansion",
    ],
    pricing: [
      { item: "NIL Contract Review", price: "$250–$400 per agreement" },
      { item: "NIL Contract Drafting", price: "$450–$750" },
      { item: "NIL Licensing Agreement", price: "$850 flat fee" },
      {
        item: "Brand Protection Package",
        price: "$650 package",
        note: "Includes contract review, risk assessment, and negotiation recommendations.",
      },
    ],
    // pricing: [
    //   {
    //     name: "NIL Strategy Consultation",
    //     desc: "A focused session to map out your NIL goals, brand direction, and risk profile with clear guidance on next steps.",
    //   },
    //   {
    //     name: "NIL Contract Review & Guidance",
    //     desc: "Detailed contract review with a plain-language breakdown of obligations, rights, risks, and negotiation considerations.",
    //   },
    // ],
    extra:
      "At Cire Legal, we view every athlete as the founder of a startup. Our mission is to empower you with comprehensive legal and strategic business services designed specifically to support your entrepreneurial journey in the evolving NIL landscape.",
  },
];
